(() => {
  if (window.HSLooxReviewsInitialized) return;
  window.HSLooxReviewsInitialized = true;

  const isDutch = () => document.documentElement.lang.toLowerCase().startsWith('nl');

  const enhanceRatings = () => {
    let enhancedCount = 0;

    document.querySelectorAll('.loox-rating[data-rating][data-raters]').forEach((ratingElement) => {
      const rating = Number(ratingElement.dataset.rating);
      const reviewCount = Number(ratingElement.dataset.raters);
      const label = ratingElement.querySelector('.loox-rating-label');

      if (!label || !Number.isFinite(rating) || !Number.isFinite(reviewCount)) return;

      const dutch = isDutch();
      const score = new Intl.NumberFormat(dutch ? 'nl-NL' : 'en-GB', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }).format(rating);
      const reviewWord = reviewCount === 1 ? 'review' : 'reviews';
      const visibleLabel = `${score} · ${reviewCount} ${reviewWord}`;
      const accessibleLabel = dutch
        ? `${score} van 5, ${reviewCount} ${reviewWord}`
        : `${score} out of 5, ${reviewCount} ${reviewWord}`;

      if (label.textContent.trim() !== visibleLabel) label.textContent = visibleLabel;
      ratingElement.setAttribute('aria-label', accessibleLabel);
      ratingElement.setAttribute('title', accessibleLabel);
      enhancedCount += 1;
    });

    return enhancedCount;
  };

  const markReviewSection = () => {
    const reviewSection = document.querySelector('#looxReviews')?.closest('.shopify-section');
    reviewSection?.classList.add('hs-loox-reviews-section');
    return Boolean(reviewSection);
  };

  const enhance = () => {
    const hasRating = enhanceRatings() > 0;
    const hasReviewSection = markReviewSection();
    if (hasRating && hasReviewSection) observer.disconnect();
  };

  document.addEventListener('DOMContentLoaded', enhance, { once: true });
  const observer = new MutationObserver(enhance);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  enhance();
})();
